import { getToken } from "./cookies";
import { _config, _resident, _user } from "./utils";

export const isLoggedIn = (): boolean => {
	return getToken() !== undefined;
};
export const clearUser = () => localStorage.removeItem(_user);
export const clearResident = () => localStorage.removeItem(_resident);
export const clearConfig = () => localStorage.removeItem(_config);